import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getLast3Months } from "../../utils/getLast3Months";
import { ApiHook } from "../../hooks/apiHook";
import { ProgressBar, Modal, Table } from "react-bootstrap";
import { getLast2Years } from "../../utils/getLast2years";
import Skeleton from "react-loading-skeleton";
import IncentivesSkeleton from "./IncentivesSkeleton";
import { formatDate } from "../../utils/formateDate";
import { useParams } from "react-router";

const EagleManager = () => {
  const params = useParams();

 
  const [selectedMonth, setSelectedMonth] = useState(getLast2Years()?.[0].year);
  const [userId, setUserId] = useState(params.id);
  const [showSupervisorModal, setShowSupervisorModal] = useState(false);
    const [showLeaderModal, setShowLeaderModal] = useState(false);
  const { t } = useTranslation();
  const [state, setState] = useState([]);
  const data = ApiHook.CallEagleManager(selectedMonth,userId);

  const handleMonthChange = (month) => setSelectedMonth(month);

  // Handle supervisor modal - changed to click instead of hover
  const handleSupervisorClick = () => {
    setShowSupervisorModal(true);
  };

  const closeSupervisorModal = () => {
    setShowSupervisorModal(false);
  };

    const handleLeaderClick = () => {
    setShowLeaderModal(true);
  };

  const closeLeaderModal = () => {
    setShowLeaderModal(false);
  };

  /**
   * Helper to render a progress bar with required values
   */
  const renderProgressBar = (item, index, levelIndex) => {
    if (!data?.data?.level?.[levelIndex]) return "N/A";

    const level = data.data.level[levelIndex];
    const required =
      index === 0
        ? level.monthThreeLess
        : index === 1
        ? level.monthTwo
        : index === 2
        ? level.monthOne
        : null;

    if (!required) return "N/A";

    return (
      <>
        <ProgressBar variant="info" now={item.totalRmpv ?? 0} max={required} />
        <span className="required-text">
          {required} {t("required") || t("Required")}
        </span>
      </>
    );
  };

  const renderIcons = (renderCondition) => {
    let isQualifiedArray = [];
    // Return null for undefined/null (optional chaining result)
    if (renderCondition == null) return null;

    return renderCondition ? (
      <i
        className="fa fa-check-circle"
        style={{
          color: "green",
          fontSize: "15px",
          position: "relative",
          top: "1px",
        }}
      />
    ) : (
      <i
        className="fa fa-times-circle"
        style={{
          color: "red",
          fontSize: "15px",
          position: "relative",
          top: "1px",
        }}
      />
    );
  };

  const isUserQualified = () => {
    if (!data?.data) return false;

    const { months, summary, config } = data.data;

    // Check all qualification criteria
    const isActiveEveryMonth = months?.every((obj) => obj.activeStatus);
    const hasEnoughTotalPv = summary?.totalPv >= config?.total_cc;
    const hasEnoughNewPv = summary?.totalNewCC >= config?.new_cc;
    const hasEnoughSupervisors =
      summary?.superVisors >= config?.supervisor_lines;

    // User is qualified only if ALL conditions are met
    return (
      isActiveEveryMonth &&
      hasEnoughTotalPv &&
      hasEnoughNewPv &&
      hasEnoughSupervisors
    );
  };

  if (data.isLoading) {
    return <IncentivesSkeleton />;
  }

  const qualified = isUserQualified();

  // Mock supervisor data - replace with actual data from your API
  const supervisorDetails = data?.data?.supervisorDetails || [
    {
      id: 1,
      name: "John Doe",
      rank: "Supervisor",
      totalPV: 1250,
      joinDate: "2024-01-15",
      active: true,
    },
    {
      id: 2,
      name: "Jane Smith",
      rank: "Senior Supervisor",
      totalPV: 1800,
      joinDate: "2024-02-20",
      active: true,
    },
    {
      id: 3,
      name: "Mike Johnson",
      rank: "Supervisor",
      totalPV: 950,
      joinDate: "2024-03-10",
      active: false,
    },
  ];

  return (
    <div className="ewallet_top_btn_sec">
      <div className="row justify-content-between">
        <div className="col-md-4"></div>
        <div className="col-md-4 text-end "></div>
      </div>
      <div className="ewallet_table_section">
        <div className="ewallet_table_section_cnt">
          <div className="table-responsive min-hieght-table">
            <h6 className="table-heading-incentives">
              {t("EagleManager")} ({data?.data?.summary?.periodRange})
            </h6>
            
            <div className="row incentives-subheading justify-content-between">
              {/* <div style={{ fontSize: "16px",padding:"10px" }}> */}
                <span>({t("Name")} : {data?.data?.fullName}</span>
                <span>{t("User Name")} : {data?.data?.username}</span>
            {/* </div> */}
              <span>
                {t("Qualified")}: {qualified || data?.data?.eagleLevel ? "YES" : "NO"}
              </span>
              <span> {t("Level")}: {data?.data?.eagleLevel || "N/A"}</span>
            </div>
            <div className="table-container">
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <h5>{t("4kcActive")}</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                        }}
                      >
                          {t("Required")}: {t("Every month")}{" "}
                        {renderIcons(
                          data?.data?.months.every((obj) => obj.activeStatus)
                        )}
                      </p>
                    </td>
                    <td colSpan={4}>
                      <div
                        style={{
                          display: "flex",
                          gap: "30px",
                          justifyContent: "space-around",
                        }}
                      >
                        {data?.data?.months.map((obj, key) => (
                          <div
                            key={key}
                            className="forver_month"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            {/* Status Indicator */}
                            <div
                              style={{
                                height: "20px",
                                width: "20px",
                                border: "1px solid green",
                                backgroundColor:
                                  obj.activeStatus > 0
                                    ? "green"
                                    : "transparent",
                              }}
                            />

                            {/* Month Label */}
                            <span style={{ fontSize: "12px" }}>
                              {obj?.month?.substring(0, 3)}
                            </span>
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h5>{t("totalPv")}</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                        }}
                      >
                        {t("You have")}:{" "}
                        {parseFloat(data?.data?.summary?.totalPv || 0).toFixed(
                          2
                        )}{" "}
                        {renderIcons(
                          data?.data?.summary?.totalPv >=
                            data?.data?.config?.total_cc
                        )}
                      </p>
                    </td>
                    <td colSpan={4}>
                      <ProgressBar
                        now={parseFloat(data?.data?.summary?.totalPv || 0)}
                        max={data?.data?.config?.total_cc || 100}
                        label={`${parseFloat(
                          data?.data?.summary?.totalPv || 0
                        ).toFixed(3)} / ${data?.data?.config?.total_cc || 0}`}
                        variant={
                          data?.data?.summary?.totalPv >=
                          data?.data?.config?.total_cc
                            ? "success"
                            : "danger"
                        }
                        style={{ minHeight: "25px", fontSize: "12px" }}
                      />
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                          textAlign: "center",
                        }}
                      >
                        {t("Required")}: {data?.data?.config?.total_cc || 0}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h5>{t("newPv")}</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                        }}
                      >
                        {t("You have")}:{" "}
                        {parseFloat(
                          data?.data?.summary?.totalNewCC || 0
                        ).toFixed(3)}{" "}
                        {renderIcons(
                          data?.data?.summary?.totalNewCC >=
                            data?.data?.config?.new_cc
                        )}
                      </p>
                    </td>
                    <td colSpan={4}>
                      <ProgressBar
                        now={parseFloat(data?.data?.summary?.totalNewCC || 0)}
                        max={data?.data?.config?.new_cc || 100}
                        label={`${parseFloat(
                          data?.data?.summary?.totalNewCC || 0
                        ).toFixed(3)} / ${data?.data?.config?.new_cc || 0}`}
                        variant={
                          data?.data?.summary?.totalNewCC >=
                          data?.data?.config?.new_cc
                            ? "success"
                            : "danger"
                        }
                        style={{ minHeight: "25px", fontSize: "12px" }}
                      />
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                          textAlign: "center",
                        }}
                      >
                        {t("Required")}: {data?.data?.config?.new_cc || 0}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={2}
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      <h5>{t("NewSupervisors")}</h5>
                      <span
                        onClick={
                          data?.data?.summary?.superVisors > 0
                            ? handleSupervisorClick
                            : undefined
                        }
                        style={{
                          cursor:
                            data?.data?.summary?.superVisors > 0
                              ? "pointer"
                              : "default",
                          color:
                            data?.data?.summary?.superVisors > 0
                              ? "#007bff"
                              : "#333",
                          textDecoration:
                            data?.data?.summary?.superVisors > 0
                              ? "underline"
                              : "none",
                          position: "relative",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          transition: "background-color 0.2s",
                        }}
                        onMouseEnter={
                          data?.data?.summary?.superVisors > 0
                            ? (e) => {
                                e.target.style.backgroundColor = "#f8f9fa";
                              }
                            : undefined
                        }
                        onMouseLeave={
                          data?.data?.summary?.superVisors > 0
                            ? (e) => {
                                e.target.style.backgroundColor = "transparent";
                              }
                            : undefined
                        }
                      >
                        {t("You have")}: {data?.data?.summary?.superVisors || 0}
                      </span>
                      {renderIcons(
                        data?.data?.summary?.superVisors >=
                          data?.data?.config?.supervisor_lines
                      )}
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                        }}
                      >
                        {t("Required")}: {data?.data?.config?.supervisor_lines || 0}{" "}
                      </p>
                    </td>
                     {/* <td
                      colSpan={2}
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      <h5>{t("Eagle Manager Lines")}</h5>
                      <span
                        onClick={
                          data?.data?.summary?.superVisors > 0
                            ? handleSupervisorClick
                            : undefined
                        }
                        style={{
                          cursor:
                            data?.data?.summary?.superVisors > 0
                              ? "pointer"
                              : "default",
                          color:
                            data?.data?.summary?.superVisors > 0
                              ? "#007bff"
                              : "#333",
                          textDecoration:
                            data?.data?.summary?.superVisors > 0
                              ? "underline"
                              : "none",
                          position: "relative",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          transition: "background-color 0.2s",
                        }}
                        onMouseEnter={
                          data?.data?.summary?.superVisors > 0
                            ? (e) => {
                                e.target.style.backgroundColor = "#f8f9fa";
                              }
                            : undefined
                        }
                        onMouseLeave={
                          data?.data?.summary?.superVisors > 0
                            ? (e) => {
                                e.target.style.backgroundColor = "transparent";
                              }
                            : undefined
                        }
                      >
                        You have : {data?.data?.summary?.superVisors || 0}
                      </span>
                      {renderIcons(
                        data?.data?.summary?.superVisors >=
                          data?.data?.config?.supervisor_lines
                      )}
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                        }}
                      >
                        Required: {data?.data?.config?.supervisor_lines || 0}{" "}
                      </p>
                    </td> */}
                  </tr>
                </tbody>
              </table>
              {/* ===== Month Tabs ===== */}
              <div className="month-tabs">
                {getLast2Years().map((year) => (
                  <button
                    key={year.value}
                    className={`month-tab ${
                      selectedMonth === year.value ? "active" : ""
                    }`}
                    onClick={() => handleMonthChange(year.value)}
                  >
                    {year.value}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Supervisor Details Modal */}
      <Modal
        show={showSupervisorModal}
        onHide={closeSupervisorModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fa fa-users me-2"></i>
            Supervisor Details ({data?.data?.summary?.superVisors || 0} Total)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {supervisorDetails && supervisorDetails.length > 0 ? (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Username</th>
                  <th>Name</th>
                  <th>Join Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.summary?.superVisorDetails.map(
                  (supervisor, index) => (
                    <tr key={supervisor.id || index}>
                      <td>{index + 1}</td>
                      <td>{supervisor.username || "N/A"}</td>
                      <td>
                        <strong>
                          {supervisor.UserDetail?.name +
                            " " +
                            supervisor.UserDetail?.secondName}
                        </strong>
                      </td>
                      {/* <td>
                      <span className="badge bg-primary">
                        {supervisor.rank || "Supervisor"}
                      </span>
                    </td>
                    <td>
                      <span className="text-success">
                        {supervisor.totalPV?.toFixed(2) || "0.00"} PV
                      </span>
                    </td> */}
                      <td>{formatDate(supervisor.dateOfJoining) || "N/A"}</td>
                      <td>
                        <span
                          className={`badge ${
                            supervisor.active ? "bg-success" : "bg-warning"
                          }`}
                        >
                          {supervisor.active ? "Active" : "Inactive"}
                        </span>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </Table>
          ) : (
            <div className="text-center py-4">
              <i className="fa fa-users fa-3x text-muted mb-3"></i>
              <p className="text-muted">No supervisor details available</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
            <div>
              <small className="text-muted">
                Total Supervisors:{" "}
                <strong>{data?.data?.summary?.superVisors || 0}</strong> |
                {t("Required")}:{" "}
                <strong>{data?.data?.config?.supervisor_lines || 0}</strong>
              </small>
            </div>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeSupervisorModal}
            >
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>


      
    </div>
  );
};

export default EagleManager;
